import { LinearProgress, Typography } from "@mui/material";
import { Box } from "@mui/system";

interface IRateChart {
  total: number;
  done: number;
  label: string;
  dir: "rtl" | "ltr";
  width: string;
  bgColor: string;
  color: string;
}

function RateChart({
  total,
  done,
  label,
  dir,
  width = "100%",
  bgColor,
  color,
}: IRateChart) {
  const value = total ? (done / total) * 100 : "-";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        width,
        textAlign: dir === "ltr" ? "left" : "right",
      }}
    >
      <Typography variant="body2" sx={{ width: "100%", color }}>
        {typeof value === "number" ? `${Math.round(value)}%` : "0%"}
      </Typography>
      <Box sx={{ width: "100%" }}>
        <LinearProgress
          variant="determinate"
          value={typeof value === "number" ? value : 0}
          sx={{
            backgroundColor: bgColor,
            height: "6px",
            borderRadius: "3px",
            "& > span": {
              backgroundColor: color,
            },
          }}
        />
      </Box>

      <Typography
        variant="subtitle2"
        color="text.secondary"
        sx={{ width: "100%", fontSize: "12px" }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export default RateChart;
